import React, { useRef } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { sumFormFormatter } from '@shared/helpers/sumFormFormatter';

import cls from './DistributeAmountItem.module.css';
import { Select } from '../../../../../../components/UI/Select/Select';

export const DistributeAmountItem = ({
    id,
    estimateSelect,
    sum,
    percent,
    formState,
    setFormState,
    isDisabled,
}) => {
    const { t } = useTranslation();
    const estimatesSelectList = useSelector((state) => state.paymentReducer.estimatesSelectList);
    const wrapperRef = useRef(null);

    const selectedEstimate = estimatesSelectList.find((item) => item.value === estimateSelect);

    const deleteHandle = () => {
        const newDistributeEstimates = formState.distributeEstimates.filter(
            (estimate) => estimate.id !== id
        );
        if (newDistributeEstimates.length <= 1) {
            setFormState((prevState) => ({
                ...prevState,
                distributeEstimates: [],
                estimates: newDistributeEstimates[0].estimateSelect,
            }));
        } else {
            setFormState((prevState) => ({
                ...prevState,
                distributeEstimates: newDistributeEstimates,
            }));
        }
    };
    const selectHandler = (value) => {
        const currentEstimate = formState.distributeEstimates.find((est) => est.id === id);
        const newState = formState.distributeEstimates.map((est) => {
            if (est.id === id) {
                return { ...currentEstimate, estimateSelect: value };
            }
            return est;
        });

        setFormState((prevState) => ({
            ...prevState,
            distributeEstimates: newState,
        }));
    };
    const inputHandler = (e) => {
        const { name, value } = e.target;

        const formattedValue = sumFormFormatter(value);

        let newSum;
        let newPercent;

        if (name === 'percent') {
            newSum =
                (Number(formState.sum.replace(',', '.')) / 100) *
                Number(formattedValue.replace(',', '.'));
            newPercent = formattedValue;
        } else {
            newSum = formattedValue;
            newPercent =
                (Number(formattedValue.replace(',', '.')) /
                    Number(formState.sum.replace(',', '.'))) *
                100;
        }
        const currentEstimate = formState.distributeEstimates.find((est) => est.id === id);

        const newState = formState.distributeEstimates.map((est) => {
            if (est.id === id) {
                return {
                    ...currentEstimate,
                    sum: String(newSum).replace('.', ','),
                    percent: String(newPercent).replace('.', ','),
                };
            }
            return est;
        });
        setFormState((prevState) => ({
            ...prevState,
            distributeEstimates: newState,
        }));
    };

    return (
        <div ref={wrapperRef} className={classNames(cls.distributeAmountItemWrapper)}>
            <Select
                isSmartPosition
                selected={selectedEstimate || null}
                onChange={selectHandler}
                placeholder={t('DistributeAmountItem.Select.placeholder')}
                options={estimatesSelectList}
            />
            <input
                name="percent"
                value={percent}
                onChange={(e) => inputHandler(e)}
                className={classNames(cls.input)}
            />
            <input
                name="sum"
                value={sum}
                className={classNames(cls.input)}
                onChange={(e) => inputHandler(e)}
            />
            <div onClick={isDisabled ? () => {} : deleteHandle} className={classNames(cls.delete)}>
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.66098 3.6609C3.81725 3.50468 4.02918 3.41691 4.25015 3.41691C4.47112 3.41691 4.68304 3.50468 4.83931 3.6609L8.00015 6.82173L11.161 3.6609C11.2379 3.58131 11.3298 3.51782 11.4315 3.47415C11.5331 3.43048 11.6425 3.40749 11.7531 3.40653C11.8638 3.40556 11.9735 3.42665 12.0759 3.46855C12.1784 3.51045 12.2714 3.57233 12.3496 3.65057C12.4279 3.72882 12.4898 3.82186 12.5317 3.92427C12.5736 4.02669 12.5947 4.13642 12.5937 4.24707C12.5927 4.35772 12.5697 4.46707 12.5261 4.56874C12.4824 4.67041 12.4189 4.76236 12.3393 4.83923L9.17848 8.00007L12.3393 11.1609C12.4911 11.3181 12.5751 11.5286 12.5732 11.7471C12.5713 11.9656 12.4837 12.1746 12.3292 12.3291C12.1747 12.4836 11.9656 12.5712 11.7471 12.5731C11.5287 12.575 11.3181 12.491 11.161 12.3392L8.00015 9.1784L4.83931 12.3392C4.68215 12.491 4.47164 12.575 4.25315 12.5731C4.03465 12.5712 3.82564 12.4836 3.67113 12.3291C3.51663 12.1746 3.42898 11.9656 3.42709 11.7471C3.42519 11.5286 3.50918 11.3181 3.66098 11.1609L6.82181 8.00007L3.66098 4.83923C3.50476 4.68296 3.41699 4.47104 3.41699 4.25007C3.41699 4.0291 3.50476 3.81717 3.66098 3.6609Z"
                        fill="#757575"
                    />
                </svg>
            </div>
        </div>
    );
};
